import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  FeedbackResponse,
  JSONApiDataObject,
  ProfileReviewResponse,
  ReduxEntity
} from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const sellerReviewsResponseAdapter = createEntityAdapter<JSONApiDataObject<ProfileReviewResponse>>({
  selectId: item => item.id
});

export const sellerReviewsResponseSlice = createSlice({
  name: 'sellerReviewsResponse',
  initialState: sellerReviewsResponseAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<FeedbackResponse>>),
  reducers: {
    sellerReviewsResponseAdded: (state, action) => {
      sellerReviewsResponseAdapter.setMany(state, action.payload);
    }
  }
});

export const sellerReviewsResponseSelectors = sellerReviewsResponseAdapter.getSelectors(
  (state: RootState) => state.sellerReviewsResponse);
export default sellerReviewsResponseSlice.reducer;
